export const SQL_WILD = '%25'
export const SLASH = '/'
export const ZERO = '0'

// TODO: make CLUB_TIME_ZONE a brand env param
// https://wyndhamexchangeandrentals.atlassian.net/browse/MAK-3385
export const MK_CLUB_TIME_ZONE = 'America/New_York'

// Sites
export const SITE_MAKO = 'siteMako'
export const SITE_WORLDMARK = 'siteWorldmark'
export const SITE_WYNDHAM = 'siteWyndham'
export const SITE_EVEREST = 'siteEverest'
export const SITE_SPORTS = 'siteSports'

// Content roots
export const SITE_MAKO_ROOT = SLASH + SITE_MAKO
export const SITE_WORLDMARK_ROOT = SLASH + SITE_WORLDMARK
export const SITE_WYNDHAM_ROOT = SLASH + SITE_WYNDHAM
export const SITE_EVEREST_ROOT = SLASH + SITE_EVEREST
export const SITE_SPORTS_ROOT = SLASH + SITE_SPORTS

// Breakpoints - to match Tailwind
export const BREAKPOINT_SM = '(max-width: 767px)' // todo: this is not correct - we should be using min-width everywhere
export const BREAKPOINT_MD = '(min-width: 768px) and (max-width: 1023px)' // todo: this is not correct - we should not be using max-width to gap this
export const BREAKPOINT_LG = '(min-width: 1024px)'

// 404 Not Found Page
export const NOT_FOUND_HOME_CTA_TEXT = 'Return Home'
export const NOT_FOUND_META_TITLE = '404 Not Found | Sports Illustrated Resorts'
export const NOT_FOUND_PAGE_BODY = "The page you're looking for was cut from the team. But there's always a way to get back in the game."
export const NOT_FOUND_PAGE_TITLE = '404'
export const NOT_FOUND_PAGE_TITLE_CAPTION = "The One's Off the Roster"
export const NOT_FOUND_RESORTS_CTA_TEXT = 'Explore Resorts'

// Maintenance page (planned / unplanned downtime) — route path; copy lives in pages/maintenance/content/*.json
export const MK_MAINTENANCE_PATH = '/maintenance'

// Idle Timeout Configuration
export const IDLE_TIMEOUT_TOTAL_MINUTES = 15
export const IDLE_TIMEOUT_WARNING_MINUTES = 13
export const IDLE_TIMEOUT_COUNTDOWN_SECONDS = 2 * 60 // 2 minutes

// Idle Timeout Modal Text
export const IDLE_TIMEOUT_MODAL_TITLE = 'Are You Still There?'
export const IDLE_TIMEOUT_MODAL_MESSAGE = "You've been inactive for a while. For your security, you'll be automatically signed out unless you choose to stay signed in."
export const IDLE_TIMEOUT_STAY_SIGNED_IN = 'Stay Signed In'
export const IDLE_TIMEOUT_SIGN_OUT = 'Sign Out'
export const IDLE_TIMEOUT_SIGNED_OUT_MESSAGE = "You've been signed out due to inactivity. Please log in again to continue."
export const IDLE_TIMEOUT_LOGGED_OUT_MESSAGE = 'You have been logged out due to inactivity.'

// Authentication Error Messages
export const LOGIN_ERROR_MESSAGE = "The username and password combination you've entered is incorrect. Please try again."

// Authentication Cookie Configuration
export const AUTH_COOKIE_EXPIRATION_HOURS = 24

// Account Lockout Configuration
export const ACCOUNT_LOCKOUT_MAX_ATTEMPTS = 5
export const ACCOUNT_LOCKOUT_DURATION_MINUTES = 15

// MFA Lockout Configuration
export const MFA_LOCKOUT_DURATION_MINUTES = 15

// Okta Storage Keys - Centralized to prevent tight coupling with Okta's internal storage
export const OKTA_CACHE_STORAGE = 'okta-cache-storage'
export const OKTA_SHARED_TRANSACTION_STORAGE = 'okta-shared-transaction-storage'
export const OKTA_ORIGINAL_URI_STORAGE = 'okta-original-uri-storage'
export const OKTA_TOKEN_STORAGE = 'okta-token-storage'
export const OKTA_TOKEN_STORAGE_KEYS = 'okta-token-storage-keys'

// Account Menu
export const ACCOUNT_MENU_AVAILABLE_POINTS_LABEL = 'pts'
export const ACCOUNT_MENU_SELECT_OWNER_ID_LABEL = 'Select Owner ID'
export const ACCOUNT_MENU_USE_BY_LABEL = 'Use by'
export const DEFAULT_CONTRACT_LABEL = 'Member'
export const CONTRACT_POINTS_LABEL = 'credits'

// Resort Availability
export const FIND_AVAILABILITY_TITLE = 'Availability'
export const LOGIN_TO_VIEW_BUTTON_TEXT = 'Login for Availability'
export const FIND_AVAILABILITY_BUTTON_TEXT = 'Find Availability'
export const SHARE = 'Share'

// Resort Availability Dialog
export const RESORT_AVAILABILITY_CHOOSE_RESORT = 'Choose a resort'
export const RESORT_AVAILABILITY_SELECT_RESORT = 'Select a resort'
export const RESORT_AVAILABILITY_INCLUDE_ACCESSIBLE_SUITES = 'Include accessible suites'
export const RESORT_AVAILABILITY_JOIN_WAITLIST = 'Join Waitlist'
export const RESORT_AVAILABILITY_SELECT_DATES = 'Select Dates'
export const RESORT_AVAILABILITY_EDIT = 'Edit'
export const RESORT_AVAILABILITY_SELECT_SUITES = 'Select Suites'
export const RESORT_AVAILABILITY_SUITE_PLACEHOLDER = 'Available suites for the selected dates will appear here.'
export const RESORT_AVAILABILITY_ALL_SUITES = 'All'

// Resort Availability Thresholds
export const RESORT_AVAILABILITY_LOW_STOCK_THRESHOLD = 7

// Resort Availability Error Messages
export const RESORT_AVAILABILITY_NO_AVAILABILITY_MESSAGE = 'This resort does not have availability for the selected dates. Please try different dates or contact customer service.'
export const RESORT_AVAILABILITY_MIN_STAY_ERROR_MESSAGE = 'This resort requires a 2-night minimum stay, but the following day is unavailable. Please try a different date.'
export const RESORT_AVAILABILITY_LOAD_ERROR_MESSAGE = 'Unable to load availability data. Please try again.'
export const RESORT_AVAILABILITY_BOOKING_ERROR_MESSAGE = 'Unable to start booking process. Please try again.'
export const RESORT_AVAILABILITY_ELIGIBILITY_ERROR_MESSAGE = 'This account does not have enough eligible benefits to complete the requested transaction.'
export const RESORT_AVAILABILITY_SELECT_SUITE_AND_DATES_MESSAGE = 'Please select a suite and dates before checking eligibility.'
export const RESORT_AVAILABILITY_SUITE_NOT_FOUND_MESSAGE = 'Selected suite not found. Please try again.'
export const RESORT_AVAILABILITY_ELIGIBILITY_CHECK_ERROR_MESSAGE =
  'We were unable to complete this action. If the problem continues contact our Vacation Planning Center for assistance.'

// Resort Availability UI Text
export const RESORT_AVAILABILITY_BOOKING_IN_PROGRESS_TEXT = 'Booking...'
export const RESORT_AVAILABILITY_AVAILABLE_TEXT = 'Available'
export const RESORT_AVAILABILITY_COST_NOT_AVAILABLE_TEXT = 'Cost not available'
export const RESORT_AVAILABILITY_CREDITS_TEXT = 'credits'
export const SUITE_PRICE_CURRENCY_USD = 'USD'
export const RESORT_AVAILABILITY_WHEELCHAIR_ACCESSIBLE_TEXT = 'Wheelchair accessible'
export const RESORT_AVAILABILITY_STUDIO_TEXT = 'Studio'
export const RESORT_AVAILABILITY_UNKNOWN_TEXT = 'Unknown'
export const RESORT_AVAILABILITY_SUITE_IMAGE_ALT_TEXT = 'Suite Image'
export const RESORT_AVAILABILITY_ERROR_SEARCHING_AVAILABILITY_TEXT = 'Error searching resort availability'
export const MISSING_SUITE_IMAGE_ALT_TEXT = 'Image on Deck'
export const MISSING_SUITE_IMAGE_ALT_TEXT_EBAC = 'Awaiting New Views'

// Profile Management
export const PROFILE_ERROR_SAVING_PROFILE = 'Error saving profile'
/** Account save API returned non-OK (e.g. 400) — performRequest yields null. */
export const PROFILE_REQUEST_FAILED_TRY_AGAIN = 'Request failed. Please try again.'
export const PROFILE_MANAGE_PASSWORD_LABEL = 'Manage password'
export const PROFILE_CHANGE_PASSWORD_LABEL = 'Change Password'
export const PROFILE_EDIT_BUTTON_TEXT = 'Edit'
export const PROFILE_CANCEL_BUTTON_TEXT = 'Cancel'
export const PROFILE_SAVE_BUTTON_TEXT = 'Save'
export const PROFILE_CURRENT_PASSWORD_LABEL = 'CURRENT PASSWORD'
export const PROFILE_NEW_PASSWORD_LABEL = 'NEW PASSWORD'
export const PROFILE_PASSWORD_SUCCESS_MESSAGE = 'Your password has been saved successfully'
export const PROFILE_PASSWORD_ERROR_MESSAGE = 'Failed to update the password.'
export const PROFILE_SAVE_SUCCESS_MESSAGE = 'Your profile has been saved successfully'
export const PROFILE_SAVE_ERROR_MESSAGE = 'Please resolve all form errors before submitting'
/**
 * Shown after a save when the post-save GET shows that one or more fields the user changed
 * did NOT persist on the server (Voyager owner-services /contacts can return 400 with a generic
 * `env:Server / unknown` body even when partial writes happened, and can also silently no-op
 * fields). Distinct from `PROFILE_SAVE_ERROR_MESSAGE` (client validation) and
 * `PROFILE_REQUEST_FAILED_TRY_AGAIN` (HTTP/network failure that returned no body).
 */
export const PROFILE_SAVE_NOT_CONFIRMED_MESSAGE = 'We could not confirm your changes were saved. Please refresh and try again.'
export const PROFILE_SAVING_BUTTON_TEXT = 'Saving...'
export const PROFILE_SAVE_ADDRESS_BUTTON_TEXT = 'Save Address'
export const PROFILE_PERSONAL_INFORMATION_TITLE = 'Personal Information'
export const PROFILE_EMAIL_ADDRESS_SECTION = 'Email Address'
export const PROFILE_EMAIL_LABEL = 'Email'
export const PROFILE_ADDRESS_SECTION = 'Address'
export const PROFILE_COUNTRY_LABEL = 'Country'
export const PROFILE_ADDRESS_LINE_1_LABEL = 'Address Line 1'
export const PROFILE_ADDRESS_LINE_2_LABEL = 'Address Line 2'
export const PROFILE_ADDRESS_LINE_3_LABEL = 'Address Line 3'
export const PROFILE_CITY_LABEL = 'City'
export const PROFILE_STATE_LABEL = 'State'
export const PROFILE_POSTAL_CODE_LABEL = 'Postal Code'
export const PROFILE_INVALID_POSTAL_CODE_MESSAGE = 'Postal code format is invalid for your country'
export const PROFILE_PHONE_NUMBER_SECTION = 'Phone Number'
export const PROFILE_HOME_PHONE_LABEL = 'Home'
export const PROFILE_MOBILE_PHONE_LABEL = 'Mobile'
export const PROFILE_WORK_PHONE_LABEL = 'Work'
export const PROFILE_CHECK_ADDRESS_HELP_TEXT = 'We found a similar address listing. Please select the address that you would like saved to your account:'
export const PROFILE_CHECK_YOUR_ADDRESS = 'Check Your Address'
export const PROFILE_USE_SUGGESTED_ADDRESS = 'Use suggested address (recommended)'
export const PROFILE_KEEP_MY_ENTERED_ADDRESS = 'Keep my entered address'

// My Account Tabs
export const MY_CONTRACTS = 'My Contracts'
export const DIGITAL_WALLET = 'Digital Wallet'
export const OWNERSHIP = 'Ownership'
export const PROFILE = 'Profile'
export const SAVED_SEARCHED = 'Saved Searches'

export const DIGITAL_WALLET_PLACEHOLDER_TEXT = 'Digital wallet features will be available here.'

// Account > Ownership Page
export const OWNERSHIP_PAGE_TITLE = 'My Contracts'
export const OWNERSHIP_PAGE_TITLE_DESCRIPTION = 'Everything you need to know about your ownership'

// Map Constants
export const DEFAULT_MAP_CENTER = { lat: 22.415212937058218, lng: -104.87723812500002 } // Center optimized for US coverage
export const DEFAULT_MAP_ZOOM = 3 // Zoom level for optimal US view

// Feature Flags
export const FEATURE_FLAGS = {
  SWITCH_MODIFY_FLOW: 'switchModifyFlow',
  /** Controls visibility of the DevUI Panel - set to true to enable developer tools */
  DEV_UI_PANEL: 'devUiPanel',
} as const

// Fallback Region Data for API failures
export const FALLBACK_REGIONS = [
  { name: 'Florida', locationPath: 'na/usa/southeast', featured: true, imgPath: '/content/images/regions/florida.jpg', imgAlt: 'Florida', resortCount: 25 },
  { name: 'California', locationPath: 'na/usa/southwest', featured: true, imgPath: '/content/images/regions/california.jpg', imgAlt: 'California', resortCount: 20 },
  { name: 'Hawaii', locationPath: 'na/usa/hawaii', featured: true, imgPath: '/content/images/regions/hawaii.jpg', imgAlt: 'Hawaii', resortCount: 15 },
  { name: 'Colorado', locationPath: 'na/usa/southwest', featured: false, imgPath: '/content/images/regions/colorado.jpg', imgAlt: 'Colorado', resortCount: 12 },
  { name: 'Arizona', locationPath: 'na/usa/southwest', featured: false, imgPath: '/content/images/regions/arizona.jpg', imgAlt: 'Arizona', resortCount: 10 },
  { name: 'Nevada', locationPath: 'na/usa/southwest', featured: false, imgPath: '/content/images/regions/nevada.jpg', imgAlt: 'Nevada', resortCount: 8 },
  { name: 'Utah', locationPath: 'na/usa/southwest', featured: false, imgPath: '/content/images/regions/utah.jpg', imgAlt: 'Utah', resortCount: 6 },
  { name: 'Texas', locationPath: 'na/usa/southwest', featured: false, imgPath: '/content/images/regions/texas.jpg', imgAlt: 'Texas', resortCount: 5 },
  { name: 'New York', locationPath: 'na/usa/northeast', featured: false, imgPath: '/content/images/regions/new-york.jpg', imgAlt: 'New York', resortCount: 4 },
  {
    name: 'South Carolina',
    locationPath: 'na/usa/southeast',
    featured: false,
    imgPath: '/content/images/regions/south-carolina.jpg',
    imgAlt: 'South Carolina',
    resortCount: 3,
  },
] as const
